<template>
    <div class="g-article-container">
        <template v-if="articles && articles.length">
            <div class="g-article-card" :class="theme" v-for="(article, index) in articles" :key="index">
                <a class="g-article-img" :href="glb.appUrl + article.url">
                    <div v-if="hasTag" class="g-article-tag" :label="tag">
                        <div class="f7">{{tag || article.firstSubCategoryName}}</div>
                        <div v-if="hasImageTitle">{{ article.title }}</div>
                    </div>
                    <img loading="lazy" :src="article.featuredImage" :alt="article.title"/>
                </a>
                <div class="g-article-content">
                    <a class="link g-article-title" :href="glb.appUrl + article.url">{{ article.title }}</a>
                    <div class="g-article-description" v-html="article.description"></div>
                    <div class="g-article-footer">
                        <a href="javascript:;" v-tip tip="author"><i v-if="!tag" class="icon-user"></i>{{ article.authorName }}</a>
                        <a class="float-right" href="javascript:;" v-tip tip="reviews"><i class="icon-eye"></i>{{$filters.formatNumber(article.pageViews)}}</a>
                    </div>
                </div>
            </div>
        </template>
        <template v-else>
            <div class="text-center markettrends-schoolcard-noresult"><i class="icon-search f1"></i> No Results</div>
        </template>
    </div>
</template>

<script src="./guidearticlecard.js"></script>

<style lang="scss">
@use "./guidearticlecard.scss" as *;
</style>